export default "__VITE_ASSET__fdf048a1__"